import { request } from '@faire/web-api--source';
import { IUser } from '@faire/web-api--source/indigofair/data/IUser';
import {
  EndpointOptions,
  PATH,
  RequestOptions,
  SuccessResponse,
} from '@faire/web-api--source/types';

export const path = (userToken: string) => {
  return `/api/user/${userToken}`;
};

export const build = (
  userToken: string,
  options?: EndpointOptions
): RequestOptions & { route: string } => {
  return {
    route,
    url: path(userToken),
    method: 'GET',
    ...options,
    headers: {
      'content-type': 'application/json',
      ...options?.headers,
    },
  };
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/user/:user_token';

/**
 * This endpoint is just for admins, logged in users can fetch the user by just calling GET /
 * Product Area: USERS
 */
function execute(userToken: string): Promise<IUser>;
function execute(
  userToken: string,
  options?: EndpointOptions & { rawResponse: true }
): Promise<SuccessResponse<IUser>>;
function execute(userToken: string, options?: EndpointOptions): Promise<IUser>;
function execute(
  userToken: string,
  options?: EndpointOptions
): Promise<IUser | SuccessResponse<IUser>> {
  const { route, ...requestOptions } = build(userToken, options);
  return request<IUser>(requestOptions);
}
execute[PATH] = 'endpoints/www/api/user/userToken/get';
export default execute;
